// Format price in EGP currency
export const formatPrice = (price) => {
  return `${price.toLocaleString('en-EG')} EGP`;
};

// Get price for a product based on selected weight
export const getProductPrice = (product, selectedWeight) => {
  if (!product || !product.pricing) return 0;
  return product.pricing[selectedWeight] || 0;
};

// Calculate item total (price × quantity)
export const calculateItemTotal = (price, quantity) => {
  return price * quantity;
};

// Calculate cart subtotal
export const calculateCartSubtotal = (cartItems) => {
  return cartItems.reduce((total, item) => {
    const price = item.price || 0;
    const quantity = item.quantity || 0;
    return total + (price * quantity);
  }, 0);
};
